import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-custom-textarea',
  template: `
    <label *ngIf="to.label" class="custom-label" [innerHTML]="to.label + (to.required ? ' <span class=&quot;text-danger&quot;>*</span>' : '')"></label>
    <!-- <label *ngIf="to.label" class="custom-label">{{ to.label }}<span class='text-danger'> *</span></label> -->
    <!-- <mat-form-field appearance="outline" class="custom-material-input"> -->
      <textarea
        matInput
        [formControl]="formControl"
        [formlyAttributes]="field"
        [placeholder]="to.placeholder"
        rows="5"
        class="custom-material-input w-100 border-radius p-2"
    ></textarea>
      <mat-error *ngIf="showError">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    <!-- </mat-form-field> -->
  `,
  styles: [
    `
    .border-radius {
        border-radius: var(--stdc-element-border-radius-size);
      }
    `,
  ],
  standalone: false
})
export class FormlyCustomTextareaComponent extends FieldType {}
